import type { Plugin } from "../../core/plugin";
import { PluginRegistry } from "../../core/pluginRegistry";

export class UserMenu implements Plugin {
  private readonly userInfo: HTMLElement | null;
  private readonly logout: HTMLElement | null;

  constructor(private readonly element: HTMLElement) {
    this.userInfo = element.querySelector("[data-navbar-user-info]");
    this.logout = element.querySelector("[data-navbar-logout]");
  }

  init(): void {
    this.userInfo?.addEventListener("click", this.handleUserInfoClick);
    this.userInfo?.addEventListener("keydown", this.handleUserInfoKeydown);
    this.close();
  }

  destroy(): void {
    this.userInfo?.removeEventListener("click", this.handleUserInfoClick);
    this.userInfo?.removeEventListener("keydown", this.handleUserInfoKeydown);
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keydown", this.handleDocumentKeydown);
  }

  private readonly handleUserInfoClick = (event: MouseEvent): void => {
    event.stopPropagation();
    this.toggle();
  };

  private readonly handleUserInfoKeydown = (event: KeyboardEvent): void => {
    if (event.key !== "Enter" && event.key !== " ") return;

    event.preventDefault();
    this.toggle();
  };

  private readonly handleDocumentClick = (event: MouseEvent): void => {
    if (!this.element.contains(event.target as Node)) {
      this.close();
    }
  };

  private readonly handleDocumentKeydown = (event: KeyboardEvent): void => {
    if (event.key === "Escape") {
      this.close();
      this.userInfo?.focus();
    }
  };

  private toggle(): void {
    if (this.logout?.hidden) {
      this.open();
    } else {
      this.close();
    }
  }

  private open(): void {
    this.logout?.removeAttribute("hidden");
    this.userInfo?.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("keydown", this.handleDocumentKeydown);
  }

  private close(): void {
    this.logout?.setAttribute("hidden", "");
    this.userInfo?.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("keydown", this.handleDocumentKeydown);
  }
}

PluginRegistry.register("trv-user-menu", UserMenu);
